// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* .LoginCoverContainer{
    position: relative;
} */


.center{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    background: white;
    border-radius: 10px;
    box-shadow: 10px 10px 15px rgba(0,0,0,0.05);
   }

   .errorMsgContainer{
    display: flex;
    justify-content: space-around;
     color: red;
   }
   .successMsgContainer{
    display: flex;
    justify-content: space-around;
     color: green;
   }

   .customdropdownLogin{
    /* background-color: red;
    width:  100%; */
  
    padding: 0;
    margin: 0;
    width: 100%;
    border-radius: 3px;
    /* background-color: gray; */
    cursor: pointer;
    border: none;
  }
  /* .customdropdown select{
    background-color: red;
  
  
  } */
  
  .customdropdownCoverLogin{ 
  
    border: none;
    padding: 15px;
    /* background-color: gray; */
    border-radius: 3px;
  
  }

   .center h1{
    text-align: center;
    padding: 20px 0;
    border-bottom: 1px solid silver;
   }
   .center form{
    padding: 0 40px;
    box-sizing: border-box;
   }
   form .txt_field{
    position: relative;
    border-bottom: 2px solid #adadad;
    margin: 30px 0;
   }
   .txt_field input{
    width: 100%;
    padding: 0 5px;
    height: 40px;
    font-size: 16px;
    border: none;
    background: none;
    outline: none;
   }
   .txt_field label{
    position: absolute;
    top: 50%;
    left: 5px;
    color: #adadad;
    transform: translateY(-50%);
    font-size: 16px;
    pointer-events: none;
    transition: .5s;
   }
   .txt_field span::before{
    content: '';
    position: absolute;
    top: 40px;
    left: 0;
    width: 0%;
    height: 2px;
    /* background: #2691d9; */
    background: #003300;
    transition: .5s;
   }
   .txt_field input:focus ~ label,
   .txt_field input:valid ~ label{
    top: -5px;
    color: #003300;
   }
   .txt_field input:focus ~ span::before,
   .txt_field input:valid ~ span::before{
    width: 100%;
   }
   .pass{
    margin: -5px 0 20px 5px;
    color: #a6a6a6;
    cursor: pointer;
   }
   .pass:hover{
    text-decoration: underline;
   }
   input[type="submit"]{
    width: 100%;
    height: 50px;
    border: 1px solid;
    background: #003300;
    border-radius: 25px;
    font-size: 18px;
    color: #e9f4fb;
    font-weight: 700;
    cursor: pointer;
    outline: none;
   }
   input[type="submit"]:hover{
    border-color: #2691d9;
    transition: .5s;
   }
   .signup_link{
    margin: 30px 0;
    text-align: center;
    font-size: 16px;
    color: #666666;
   }
   .signup_link a{
    color: #003300;
    text-decoration: none;
   }
   .signup_link a:hover{
    text-decoration: underline;
   
   }
   
   .formLogo {
    width: 100%;
    /* background-color: red; */
    justify-content: space-around;
    display: flex;
    cursor: pointer;
   
   
   }
   .formLogo img{
    
    width: 170px;
   
   }`, "",{"version":3,"sources":["webpack://./src/Pages/Login/Login.css"],"names":[],"mappings":";;AAEA;;GAEG;;;AAGH;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;GAC5C;;GAEA;IACC,aAAa;IACb,6BAA6B;KAC5B,UAAU;GACZ;GACA;IACC,aAAa;IACb,6BAA6B;KAC5B,YAAY;GACd;;GAEA;IACC;mBACe;;IAEf,UAAU;IACV,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,YAAY;EACd;EACA;;;;KAIG;;EAEH;;IAEE,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;;EAEpB;;GAEC;IACC,kBAAkB;IAClB,eAAe;IACf,+BAA+B;GAChC;GACA;IACC,eAAe;IACf,sBAAsB;GACvB;GACA;IACC,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;GACf;GACA;IACC,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;GACd;GACA;IACC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,oBAAoB;IACpB,eAAe;GAChB;GACA;IACC,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;GAChB;GACA;;IAEC,SAAS;IACT,cAAc;GACf;GACA;;IAEC,WAAW;GACZ;GACA;IACC,uBAAuB;IACvB,cAAc;IACd,eAAe;GAChB;GACA;IACC,0BAA0B;GAC3B;GACA;IACC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;GACd;GACA;IACC,qBAAqB;IACrB,eAAe;GAChB;GACA;IACC,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;GACf;GACA;IACC,cAAc;IACd,qBAAqB;GACtB;GACA;IACC,0BAA0B;;GAE3B;;GAEA;IACC,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,aAAa;IACb,eAAe;;;GAGhB;GACA;;IAEC,YAAY;;GAEb","sourcesContent":["\n\n/* .LoginCoverContainer{\n    position: relative;\n} */\n\n\n.center{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 400px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 10px 10px 15px rgba(0,0,0,0.05);\n   }\n\n   .errorMsgContainer{\n    display: flex;\n    justify-content: space-around;\n     color: red;\n   }\n   .successMsgContainer{\n    display: flex;\n    justify-content: space-around;\n     color: green;\n   }\n\n   .customdropdownLogin{\n    /* background-color: red;\n    width:  100%; */\n  \n    padding: 0;\n    margin: 0;\n    width: 100%;\n    border-radius: 3px;\n    /* background-color: gray; */\n    cursor: pointer;\n    border: none;\n  }\n  /* .customdropdown select{\n    background-color: red;\n  \n  \n  } */\n  \n  .customdropdownCoverLogin{ \n  \n    border: none;\n    padding: 15px;\n    /* background-color: gray; */\n    border-radius: 3px;\n  \n  }\n\n   .center h1{\n    text-align: center;\n    padding: 20px 0;\n    border-bottom: 1px solid silver;\n   }\n   .center form{\n    padding: 0 40px;\n    box-sizing: border-box;\n   }\n   form .txt_field{\n    position: relative;\n    border-bottom: 2px solid #adadad;\n    margin: 30px 0;\n   }\n   .txt_field input{\n    width: 100%;\n    padding: 0 5px;\n    height: 40px;\n    font-size: 16px;\n    border: none;\n    background: none;\n    outline: none;\n   }\n   .txt_field label{\n    position: absolute;\n    top: 50%;\n    left: 5px;\n    color: #adadad;\n    transform: translateY(-50%);\n    font-size: 16px;\n    pointer-events: none;\n    transition: .5s;\n   }\n   .txt_field span::before{\n    content: '';\n    position: absolute;\n    top: 40px;\n    left: 0;\n    width: 0%;\n    height: 2px;\n    /* background: #2691d9; */\n    background: #003300;\n    transition: .5s;\n   }\n   .txt_field input:focus ~ label,\n   .txt_field input:valid ~ label{\n    top: -5px;\n    color: #003300;\n   }\n   .txt_field input:focus ~ span::before,\n   .txt_field input:valid ~ span::before{\n    width: 100%;\n   }\n   .pass{\n    margin: -5px 0 20px 5px;\n    color: #a6a6a6;\n    cursor: pointer;\n   }\n   .pass:hover{\n    text-decoration: underline;\n   }\n   input[type=\"submit\"]{\n    width: 100%;\n    height: 50px;\n    border: 1px solid;\n    background: #003300;\n    border-radius: 25px;\n    font-size: 18px;\n    color: #e9f4fb;\n    font-weight: 700;\n    cursor: pointer;\n    outline: none;\n   }\n   input[type=\"submit\"]:hover{\n    border-color: #2691d9;\n    transition: .5s;\n   }\n   .signup_link{\n    margin: 30px 0;\n    text-align: center;\n    font-size: 16px;\n    color: #666666;\n   }\n   .signup_link a{\n    color: #003300;\n    text-decoration: none;\n   }\n   .signup_link a:hover{\n    text-decoration: underline;\n   \n   }\n   \n   .formLogo {\n    width: 100%;\n    /* background-color: red; */\n    justify-content: space-around;\n    display: flex;\n    cursor: pointer;\n   \n   \n   }\n   .formLogo img{\n    \n    width: 170px;\n   \n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
